import http from '@/plugins/http';
import ENDPOINTS from '@/constants/endpoints.constant';

/**
 * @returns {Promise} Promise object containing all tenants
 */
export const getTenants = () => {
  return http.get(ENDPOINTS.TENANTS);
};
